import React, { useContext, useState } from "react";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { AuthContext } from "../../context/auth/AuthContext";
import { Request } from "../../api/eklok/Eklok.api";

const ActiveEklokContainer = ({ children, setResult = () => {} }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token } = useContext(AuthContext);

  const onSubmit = (values, actions) => {
    setError(null);
    setLoading(true);
    Request.activationEklok(token.access, values.eklok)
      .then((data) => onSuccess(data, actions))
      .catch((error) => onFailure(error, actions));
  };

  const onSuccess = (data, actions) => {
    actions.setSubmitting(false);
    setLoading(false);
    setResult({
      "Support ID": data.data.data.id_support,
      "Plant ID": data.data.data.id_plant,
      "Activation Key": data.data.data.code,
    });
  };

  const onFailure = (error, actions) => {
    setError(error);
    setLoading(false);
    actions.setSubmitting(false);
  };

  return (
    <>
      {error ? <Error message={error} onClose={() => setError(null)} /> : null}
      {loading ? <Loading /> : null}
      {children({ onSubmit })}
    </>
  );
};

export default ActiveEklokContainer;
